export default __webpack_public_path__ + "static/media/annekhi.cc6470a2.jpeg";